import { render, staticRenderFns } from "./AdministrationSettingsCategory.vue?vue&type=template&id=24870e0d&"
import script from "./AdministrationSettingsCategory.vue?vue&type=script&lang=js&"
export * from "./AdministrationSettingsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports